import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule, CdkOverlayOrigin } from '@angular/cdk/overlay';

@Component({
  selector: 'app-widget-edit',
  standalone: true,
  imports: [CommonModule, OverlayModule],
  templateUrl: './widget-edit.html',
  styleUrl: './widget-edit.scss',
})
export class WidgetEdit {
  introWorkFlage: boolean = false;
  @Input() editTrigger!: CdkOverlayOrigin;
  @Input() index!: number;
  @Input() activeDropdownIndex: number | null = null;
  @Input() getAvailableSizes!: (index: number) => Array<{ value: string; label: string }>;
  @Input() changeWidgetSize!: (index: number, size: string) => void;
  @Input() removeWidget!: (index: number) => void;
  @Input() toggleSizeDropdown!: (index: number, event: Event) => void;
}
